import React from 'react';

// Função para criar notificações padronizadas
export const showNotification = (message, type = 'success', duration = 3000) => {
  // Remove notificações existentes para evitar sobreposição
  const existingNotifications = document.querySelectorAll('.notification-toast');
  existingNotifications.forEach(notification => notification.remove());

  const notification = document.createElement('div');
  
  // Classes base
  let baseClasses = 'fixed top-4 right-4 px-4 py-3 rounded-lg shadow-lg z-50 transition-all duration-300 transform translate-x-full opacity-0';
  
  // Classes específicas por tipo
  let typeClasses = '';
  let icon = '';
  
  switch (type) {
    case 'success':
      typeClasses = 'bg-green-500 text-white';
      icon = `
        <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
        </svg>
      `;
      break;
    case 'warning':
      typeClasses = 'bg-orange-500 text-white';
      icon = `
        <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.5 0L4.268 19.5c-.77.833.192 2.5 1.732 2.5z" />
        </svg>
      `;
      break;
    case 'error':
      typeClasses = 'bg-red-500 text-white';
      duration = 5000; // Erros ficam mais tempo visíveis
      icon = `
        <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      `;
      break;
    case 'info':
      typeClasses = 'bg-blue-500 text-white';
      icon = `
        <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      `;
      break;
    default:
      typeClasses = 'bg-gray-500 text-white';
  }

  notification.className = `notification-toast ${baseClasses} ${typeClasses} flex items-center`;
  notification.innerHTML = `
    <div class="flex items-center">
      ${icon}
      <span class="font-medium">${message}</span>
    </div>
    <button class="ml-3 text-white hover:text-gray-200 transition-colors" onclick="this.parentElement.remove()">
      <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>
  `;

  document.body.appendChild(notification);

  // Anima a entrada
  setTimeout(() => {
    notification.style.transform = 'translateX(0)';
    notification.style.opacity = '1';
  }, 10);

  // Remove após o tempo especificado
  setTimeout(() => {
    notification.style.transform = 'translateX(full)';
    notification.style.opacity = '0';
    setTimeout(() => {
      if (notification.parentElement) {
        notification.remove();
      }
    }, 300);
  }, duration);
};

// Componente React para usar em JSX (opcional)
const Notification = ({ message, type, isVisible, onClose }) => {
  if (!isVisible) return null;

  let typeClasses = '';
  let icon = '';
  
  switch (type) {
    case 'success':
      typeClasses = 'bg-green-500 text-white';
      icon = '✓';
      break;
    case 'warning':
      typeClasses = 'bg-orange-500 text-white';
      icon = '⚠';
      break;
    case 'error':
      typeClasses = 'bg-red-500 text-white';
      icon = '✗';
      break;
    case 'info':
      typeClasses = 'bg-blue-500 text-white';
      icon = 'ℹ';
      break;
    default:
      typeClasses = 'bg-gray-500 text-white';
      icon = 'ℹ';
  }

  return (
    <div className={`fixed top-4 right-4 px-4 py-3 rounded-lg shadow-lg z-50 transition-all duration-300 ${typeClasses} flex items-center`}>
      <span className="mr-2">{icon}</span>
      <span className="font-medium">{message}</span>
      <button 
        onClick={onClose}
        className="ml-3 text-white hover:text-gray-200 transition-colors"
      >
        ✗
      </button>
    </div>
  );
};

export default Notification;
